export const PRINT_RESPONSE_LOCAL_STORAGE_KEY = 'print_response';
